class VwKullanicivtysgrupDTO {
    vtysgrup?: number = null;
    id: number = null;
    adi?: string = "";
    aktif?: string = "E";
    aktifBool?: boolean = false;
    bagliorganizasyonId?: string = "";
    treekey?: string = "";
}
export default VwKullanicivtysgrupDTO;